import React from 'react';

// A guard that intercepts an entity change. It receives a `proceed` callback to
// run once the user has confirmed they're happy to leave (e.g. discarding an
// in-progress bonus override). Registering `undefined` clears the guard.
export type EntityChangeGuard = (proceed: () => void) => void;

interface SelectedEntityContextType {
  entityField: string;
  selectedEntity?: string;
  selectedEntityDocument?: ElasticDocument;
  onEntitySelected: (newValue: string) => void;
  setEntityChangeGuard: (guard: EntityChangeGuard | undefined) => void;
  // Called when the selected entity has no data for the current period (e.g. a
  // driver's bonus record request 400s after switching to a period they aren't
  // in). Deselects the entity, closes the slideout and toasts the reason, so the
  // slideout doesn't stay open stuck on spinners.
  onEntityUnavailable: () => void;
}

const SelectedEntityContext = React.createContext<SelectedEntityContextType>({
  entityField: 'NA',
  selectedEntity: undefined,
  onEntitySelected: () => {
    const e = new Error();
    e.name = `onEntitySelected is not defined`;
    throw e;
  },
  setEntityChangeGuard: () => {},
  onEntityUnavailable: () => {},
});

export default SelectedEntityContext;
